export default "__VITE_ASSET__1CXcSjhn__"